import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "template", "entry"]

  add() {
    const template = this.templateTarget.content.cloneNode(true)
    this.containerTarget.appendChild(template)
  }

  remove(event) {
    const entry = event.target.closest("[data-reading-schedule-target='entry']")
    if (entry) entry.remove()
  }

  sort() {
    const entries = Array.from(this.entryTargets)
    entries.sort((a, b) => {
      const aVal = a.querySelector("input[type='time']").value
      const bVal = b.querySelector("input[type='time']").value
      return aVal.localeCompare(bVal)
    })
    entries.forEach(entry => this.containerTarget.appendChild(entry))
  }
}
